// extracted by mini-css-extract-plugin
export var content = "_p7-1";
export var noScroll = "_p7-3";
export var paper = "_p7-0";
export var scrollable = "_p7-2";